import { TScenario } from "pages/scenarios/scenario.model"
import { useState } from "react"
export const SORT_TYPES = [null, "asc", "desc"]
export const SORT_BY = {
    NAME: "NAME",
    CASE_STUDY: "CASE_STUDY",
    LEVEL: "LEVEL",
    PROVINCE: "PROVINCE",
    TAX_PAYER: "TAX_PAYER",
    PUBLISHED: "PUBLISHED"
}

type columnProps = "name" | "casestudyNumber" | "taxpayerName" | "level" | "province" | "isPublished"

const useSortScenarioList = () => {
    const [sortIndex, setSortIndex] = useState(0)
    const [sortBy, setSortBy] = useState("")

    const handleSortToggle = (byColumnId: string) => {
        if(sortBy !== byColumnId) setSortIndex(1)
        else setSortIndex((prev) => (prev + 1) % 3)
        setSortBy(byColumnId)
    }

    const sortList = (arr: Array<TScenario> = []) => {
        const sortOrder = SORT_TYPES[sortIndex] === "asc" ? 1 : -1
        if (!SORT_TYPES[sortIndex] || !sortBy) return arr

        const sortByColumnType = (pid: columnProps) => {
            if(pid !== "isPublished")
                {
                return arr?.slice()?.sort((a, b) => sortOrder * a[pid].localeCompare(b[pid], undefined, { numeric: true, }))
            }
            else if(pid === "isPublished"){
                if(SORT_TYPES[sortIndex] === "asc"){
                  return arr.sort((a:any, b:any) => {return (a.isPublished - b.isPublished)});
                }
                else if(SORT_TYPES[sortIndex] === "desc"){
                    return arr.sort((b:any, a:any) => {return (a.isPublished - b.isPublished)});
                }            
            }
        }

        switch (sortBy) {
            case SORT_BY.NAME:
                return sortByColumnType("name")
            case SORT_BY.CASE_STUDY:
                return sortByColumnType("casestudyNumber")
            case SORT_BY.LEVEL:
                return sortByColumnType("level")
            case SORT_BY.PROVINCE:
                return sortByColumnType("province")
            case SORT_BY.TAX_PAYER:
                return sortByColumnType("taxpayerName")
            case SORT_BY.PUBLISHED:
                    return sortByColumnType("isPublished")
            default:
                return arr
        }
    }

    return {
        sortIndex,
        sortList,
        sortBy,
        handleSortToggle
    }
}

export default useSortScenarioList
